import { FunnelPage } from '~/components/funnel-page';
import { useFunnel } from '~/hooks/use-funnel';
import { solarScreenMap } from '~/machines/solar-funnel/screen-map';
import { BillUploadContainer } from '~/screens/bill-upload/bill-upload.container';
import { screenMapOverride } from '~/utils/funnels';
import { copy } from './copy';
import { funnelMachine } from './machine';

const screenMap = screenMapOverride(solarScreenMap, {
  enrollment: {
    billUpload: props => (
      <BillUploadContainer {...props} overrideProps={{ context: { pagesRequired: 1 } }} />
    ),
  },
});

export const Funnel = () => {
  const { funnel, micro, step, overrideCopy, Screen } = useFunnel({
    funnelMachine,
    screenMap,
    copy,
  });

  return (
    <FunnelPage funnel={funnel} micro={micro} step={step}>
      <Screen funnel={funnel} micro={micro} overrideCopy={overrideCopy} />
    </FunnelPage>
  );
};
